import { LeafBreadcrumbsItem } from "./breadcrumbs-item.component.js";
customElements.define("leaf-breadcrumbs-item", LeafBreadcrumbsItem);
export {
  LeafBreadcrumbsItem
};
//# sourceMappingURL=breadcrumbs-item.js.map
